// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export var EDealType = /*#__PURE__*/function (EDealType) {
  /** Аренда **/
  EDealType["Rent"] = "rent";
  /** Продажа **/
  EDealType["Sale"] = "sale";
  return EDealType;
}({});
export var EEntityType = /*#__PURE__*/function (EEntityType) {
  /** ЖК **/
  EEntityType["Newbuilding"] = "newbuilding";
  /** Коммерческая **/
  EEntityType["OfferCommercial"] = "offerCommercial";
  /** Жилая **/
  EEntityType["OfferResidental"] = "offerResidental";
  /** Загородка **/
  EEntityType["OfferSuburban"] = "offerSuburban";
  return EEntityType;
}({});